import { useTrans } from '@/shared/hooks/useTranslation';
import type { AnnouncementNoteView, ReleaseNoteCategory } from '@/viewmodel/shared/versionCheck';
import {
  Bot,
  Bug,
  type LucideIcon,
  ShieldCheck,
  Sparkle,
  TriangleAlert,
  Wand2,
  Wrench,
  Zap,
} from 'lucide-react';

const CATEGORY_ICONS: Record<ReleaseNoteCategory, LucideIcon> = {
  ux: Wand2,
  performance: Zap,
  agent: Bot,
  fix: Bug,
  security: ShieldCheck,
  breaking: TriangleAlert,
  internal: Wrench,
  other: Sparkle,
};

interface AnnouncementListProps {
  notes: AnnouncementNoteView[];
}

export function AnnouncementList({ notes }: Readonly<AnnouncementListProps>) {
  const { t } = useTrans();

  return (
    <ul className="flex flex-col gap-4">
      {notes.map((note) => {
        const Icon = CATEGORY_ICONS[note.category];
        return (
          <li key={note.key} className="flex gap-3">
            <Icon
              size={16}
              className="mt-0.5 shrink-0 text-primary"
              aria-label={t(`whatsNew.category.${note.category}`)}
            />
            <div className="flex flex-col gap-0.5">
              <p className="text-sm font-medium text-foreground">{note.title}</p>
              <p className="text-sm text-muted-foreground">{note.body}</p>
            </div>
          </li>
        );
      })}
    </ul>
  );
}
